import type { ReferralEvent } from '@/supabase/referral/repository/referralEventRepository';

/** undefined = 로딩 중 또는 조회 실패, null = 진행 중 이벤트 없음 */
export type ReferralEventState = ReferralEvent | null | undefined;

/** 새 가입자에게 이벤트 혜택을 광고해도 되는 상태 */
export function isEventOpen(event: ReferralEventState): event is ReferralEvent {
  return !!event && !event.is_full && Date.parse(event.end_at) > Date.now();
}

export type RefereeRewardLabel =
  | { kind: 'hidden' } // 이벤트 상태 미확정 — 혜택 줄 자체를 숨긴다(1→3 깜빡임·장애 시 오표시 방지)
  | { kind: 'base' } // 평시 가입: +1개월
  | { kind: 'event'; months: number; maxReferees: number | null } // 지금 결제하면 이벤트 보상 후보
  | { kind: 'confirm' }; // 이벤트 가입이지만 개월 수는 승인 시 확정(결제 후 대기·마감·종료·레거시)

/**
 * 피추천인 화면(초대장 카드·환영 모달·마이페이지)의 추가 혜택 표기 규칙.
 * 선착순 순위는 프론트에서 재현하지 않는다 — 확정은 승인 엣지만.
 */
export function refereeRewardLabel(
  referral: { event_id: number | null; is_event_period: boolean; first_payment_at: string | null },
  event: ReferralEventState,
): RefereeRewardLabel {
  if (event === undefined) return { kind: 'hidden' };
  if (!referral.is_event_period) return { kind: 'base' };
  if (isEventOpen(event) && referral.event_id === event.id && !referral.first_payment_at) {
    return { kind: 'event', months: event.reward_multiplier, maxReferees: event.max_referees };
  }
  return { kind: 'confirm' };
}

/** end_at은 배타적 상한(예: 2027-01-01 00:00) → 표시는 마지막 날(12월 31일) */
export function formatEventLastDay(endAt: string): string {
  const lastDay = new Date(Date.parse(endAt) - 1);
  return `${lastDay.getMonth() + 1}월 ${lastDay.getDate()}일`;
}
